import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import MuiFormControl from "@material-ui/core/FormControl";
import classNames from "classnames";
export const FormControl = props => {
  const {
    id,
    className,
    disabled,
    children,
    ...otherProps
  } = props;
  return /*#__PURE__*/React.createElement(MuiFormControl, _extends({
    id: id ? `${id}-form-control` : undefined,
    className: classNames("prmbl-formControl", className),
    disabled: disabled,
    "aria-disabled": disabled,
    margin: "normal"
  }, otherProps), children);
};
export default FormControl;